import React from "react";
import { useNavigate } from "react-router";

export default function EmptyCart() {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center animate-2"
      style={{ height: window.innerHeight - 40 }}
    >
      <i className="uil uil-shopping-bag fs-xxl text-grey"></i>
      <div className="fs-3 text-center lh-1 text-grey">
        Cart feels lonely <br /> <br />
        <i className="uil uil-frown fs-lg"></i>
        <i className="uil uil-frown fs-lg"></i>
        <i className="uil uil-frown fs-lg"></i>
      </div>

      <div className="fixed-bottom empty-cart-bottom ">
        <button
          className="d-flex btn btn-orange d-flex justify-content-center"
          onClick={() => navigate(-1)}
        >
          <span className="my-auto">Cheer up my cart</span>
          <i className="ms-3 bi bi-arrow-right fs-3 pt-1"></i>
        </button>
      </div>
    </div>
  );
}
